module.exports = __webpack_public_path__ + "img/ic_profile_gem.b3323286.png";